import {ChartPlotColors} from "../constants/chartColors";

/**
 * Aggregates daily stats across selected sites into time-series chart format.
 * @param {Object} payload - keyed by locationId, each with `dailyStats`
 * @param {Array} [excludedSites] - optional set of site keys to exclude
 * @param {Array} [excludedDirections] - optional set of direction keys to exclude
 * @param {Set<string>} [allowedSites] - optional set of site keys to include
 * @returns {{ series: ApexAxisChartSeries, colors: string[] }}
 */
export function prepareVehicleOverloadTimelineSeriesGrouped(
    payload = {},
    excludedSites= [],
    excludedDirections = [],
    allowedSites = null) {

  const sumKeys = [
    "numAllVehicles",
    "numAllOverloadedVehicles",
    "numTotalMassOverLimit",
    "numAxleLoadOverLimit",
    "numMassAndAxleOverLimit"
  ];

  const translationMap = {
    numAllVehicles: "dashboards_view.kpi2.line_overload_trends.series.total",
    numAllOverloadedVehicles: "dashboards_view.kpi2.line_overload_trends.series.overloaded",
    numTotalMassOverLimit: "dashboards_view.kpi2.line_overload_trends.series.only_mass",
    numAxleLoadOverLimit: "dashboards_view.kpi2.line_overload_trends.series.only_axle",
    numMassAndAxleOverLimit: "dashboards_view.kpi2.line_overload_trends.series.both"
  };

  const dateMap = {}; // { date: { sumKey1: value, ... } }

  for (const [siteKey, {dailyStats = []}] of Object.entries(payload)) {
    if (allowedSites && !allowedSites.has(siteKey)) {
      continue;
    }
    if (excludedSites && excludedSites.indexOf(siteKey) !== -1) {
      continue;
    }
    let continueFlag = false;
    for (const stat of dailyStats) {
      continueFlag = false;
      const date = stat.measurementDate;
      if (!date) {
        continueFlag = true;
        console.log("set continueFlag", continueFlag);
        continue;
      }
      if (excludedDirections && excludedDirections.indexOf(stat?.direction) !== -1) {
        console.log("set continueFlag", continueFlag);
        continueFlag = true;
        continue; // continue vs break???
      } else if (excludedDirections && excludedDirections.indexOf("N/A") !== -1 && stat?.direction === "") {
        continueFlag = true;
        continue;
      }
      if (continueFlag) {
        console.log("continueFlag", continueFlag);
      }

      if (!dateMap[date]) {
        dateMap[date] = {};
        sumKeys.forEach(k => (dateMap[date][k] = 0));
      }

      sumKeys.forEach(k => {
        dateMap[date][k] += stat[k] ?? 0;
      });
    }
  }

  if (!sumKeys || sumKeys.length === 0) {
    return {};
  }
  const series = sumKeys.map(key => ({
    name: translationMap[key],
    data: Object.entries(dateMap)
    .map(([date, valueMap]) => ({
      x: new Date(date).getTime(),
      y: valueMap[key]
    }))
    .sort((a, b) => a.x - b.x)
  }));

  return {
    series,
    colors: [
      ChartPlotColors.TOTAL_VEHICLES_LINE,
      ChartPlotColors.OVERLOADED_LINE,
      ChartPlotColors.MASS_ONLY,
      ChartPlotColors.AXLE_ONLY,
      ChartPlotColors.BOTH
    ],
    labels: [
      "dashboards_view.kpi2.line_overload_trends.series.total",
      "dashboards_view.kpi2.line_overload_trends.series.overloaded",
      "dashboards_view.kpi2.line_overload_trends.series.only_mass",
      "dashboards_view.kpi2.line_overload_trends.series.only_axle",
      "dashboards_view.kpi2.line_overload_trends.series.both"
    ]
  };
}
